<template>
  <div :class="[cssCls, customClass]">
    <ms-label
      :style="labelStyle"
      :required="!allowBlank"
    >
      {{ label }}
    </ms-label>

    <el-input
      ref="input"
      v-model="value"
      :class="{ error: hasError }"
      @change="onChange"
      @focus="onFocus"
      v-bind="attrs"
    >
      <template
        v-for="(index, name) in $slots"
        #[name]
      >
        <slot :name="name" />
      </template>
    </el-input>

    <span
      class="error-msg"
      v-if="hasError"
      v-html="errorMessage"
    />
  </div>
</template>

<script>
import { UPDATE_MODEL_EVENT, CHANGE_EVENT, BLUR_EVENT } from '../utils/constants'
import { label, useLabel } from '../utils/label'
import { useValidate, validate, getValidationProps } from '../utils/validate'
import ElInput from '../input'

export default {
  name: 'MsTextField',

  mixins: [label, validate],

  inheritAttrs: false,

  components: {
    ElInput
  },

  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT, BLUR_EVENT],

  methods: {
    /**
     * focus vào text-field
     */
    focus () {
      this.$refs.input.focus()
    },

    /**
     * blur khỏi text-field
     */
    blur () {
      this.$refs.input.blur()
    }
  },

  setup (props, context) {
    const { labelCls, labelStyles } = useLabel(props)
    const validationObj = useValidate(props, context)
    const validationProps = getValidationProps(validationObj)

    return {
      labelCls,
      labelStyles,
      ...validationProps
    }
  },

  computed: {
    cssCls () {
      const me = this

      return {
        'ms-text-field': true,
        'has-error': me.hasError,
        ...me.labelCls,
        [me.validateCls]: true
      }
    },

    labelStyle () {
      return {
        ...this.labelStyles
      }
    },

    attrs () {
      const me = this

      return {
        ...me.$attrs,
        onChange: me.onChange,
        onBlur: me.onBlur,
        onFocus: me.onFocus
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.ms-text-field {
  @include field-label();

  @include has(error) {
    :deep(.el-input__inner) {
      border-color: $color-error !important;
    }
  }

  @include error-msg()
}
</style>
